import React from 'react';
import { Group, Button, Loader } from '@mantine/core';
import { FormattedMessage } from 'react-intl';
import useFormGroupEditionButtonStyles from './useFormGroupEditionButtonStyles';

export interface FormGroupEditionButtonProps {
  onCancel: () => void;
  labelSubmit?: string;
  labelCancel?: string;
  isButtonDisabled?: boolean;
  isLoading?: boolean;
}

const FormGroupEditionButton = ({
  onCancel,
  labelSubmit,
  labelCancel,
  isButtonDisabled = false,
  isLoading = false,
}: FormGroupEditionButtonProps) => {
  const { classes } = useFormGroupEditionButtonStyles();

  return (
    <Group position="center" mt="xl">
      <Button color="red" type="button" onClick={onCancel}>
        <FormattedMessage id={labelCancel ?? 'typeBase.labelBtnCancel'} defaultMessage="Cancel" />
      </Button>
      <Button color="blue" type="submit" disabled={isButtonDisabled}>
        <FormattedMessage id={labelSubmit ?? 'typeBase.labelBtnSave'} defaultMessage="Save" />
        {isLoading && <Loader className={classes?.button} size={15} variant="oval" />}
      </Button>
    </Group>
  );
};

export default FormGroupEditionButton;
